import React, { Component } from 'react'
import Stars from './stars'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import { SemanticUIColors } from './semanticUIColors'

interface Props {
  averageRating?: number
  inverted: boolean
  question: string
  ratingHandler: (question: string, selectedRating: number) => void
  starAmount: number
  starColor: SemanticUIColors
  votingIsOver: boolean
}

interface State {
  currentlySelectedRating: number
}

/**
 * Renders a single question, including the interactive stars
 */
export class Question extends Component<Props, State> {
  public static defaultProps = {
    inverted: false,
    starAmount: 5,
    starColor: 'yellow',
    votingIsOver: false
  }

  public state = {
    currentlySelectedRating: -1
  }

  /**
   * Handle clicks on a star
   */
  private handleClick = (selectedRating: number) => {
    if (!this.props.votingIsOver) {
      this.setState({
        currentlySelectedRating: selectedRating
      })
      this.props.ratingHandler(this.props.question, selectedRating)
    }
  }

  public render() {
    return (
      <tr>
        <td>{this.props.question}</td>
        <td className={`single line right aligned`}>
          <Stars
            averageRating={this.props.averageRating}
            clickHandler={this.handleClick}
            inverted={this.props.inverted}
            currentlySelectedRating={this.state.currentlySelectedRating}
            starAmount={this.props.starAmount}
            starColor={this.props.starColor}
            votingIsOver={this.props.votingIsOver}
          />
        </td>
      </tr>
    )
  }
}

export default Question
